import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";
import { ClientPortalWebNarrativeModel } from "services/api/cplapi/CPLAPI";
import { IClientPortalWebNarrativesService } from "services/ClientPortalWebNarrativesService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { RootState } from "setup/redux/RootReducer";

type WebNarrativeState = {
  Loading: boolean;
  WebNarrative: ClientPortalWebNarrativeModel;
};

const initialState: WebNarrativeState = {
  Loading: false,
  WebNarrative: new ClientPortalWebNarrativeModel(),
};

export const webNarrativeSlice = createSlice({
  name: "WebNarrative",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWebNarrative.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getWebNarrative.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getWebNarrative.fulfilled, (state, action) => {
        state.WebNarrative = action.payload;
        state.Loading = false;
      });
  },
});

export const getWebNarrative = createAsyncThunk<ClientPortalWebNarrativeModel, ClientPortalWebNarratives>(
  "WebNarrative/GetWebNarratives",
  async (webNarrativeID) => {
    const webNarrativesService = container.get<IClientPortalWebNarrativesService>(
      SERVICE_TYPES.ClientPortalWebNarrativesService
    );
    return await webNarrativesService.getClientPortalWebNarrative(webNarrativeID);
  }
);

export const selectLoading = (state: RootState) => state.webNarrative.Loading;
export const selectWebNarrative = (state: RootState) => state.webNarrative.WebNarrative;

export default webNarrativeSlice.reducer;
